import { Box, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
};

const TitleBar = ({ sx, children }: Props) => (
  <Box
    sx={{
      width: '100%',
      mx: 'auto',
      my: 0,
      p: 1,
      textAlign: 'center',
      bgcolor: baseColors.red,
      ...sx
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: baseColors.white
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default TitleBar;
